import React, { FC, useMemo } from "react"
import { MiniDeLoading } from "../../../components/DeLoading"
import { truncateAddress } from "../../../utils"
import { WLQualification } from "../../../types/wl-management"

type Props = {
  isLoading: boolean
  qualifications: WLQualification[]
  search?: string
}

const WhitelistTable: FC<Props> = ({ isLoading, qualifications, search }) => {
  const filteredQualifications = useMemo(() => {
    if (!search) return qualifications
    return qualifications.filter(
      (qualification) =>
        qualification.user?.username?.includes(search) ||
        qualification.user?.twitter_username?.includes(search) ||
        qualification.user?.discord_username?.includes(search) ||
        qualification.primary_wallet?.includes(search)
    )
  }, [search, qualifications])

  return (
    <div className="h-full rounded-x10 border-spacing-y-10 border-spacing-x-0 overflow-hidden border border-kyzzen-secondary">
      <div className="app-table w-full overflow-auto h-full block">
        <table className="rounded-lg border-separate border-spacing-0">
          <thead>
            <tr>
              <th className="w-[1%] px-2.5 py-3 whitespace-nowrap group/th font-medium text-sm text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary">
                #
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky z-1 top-0 left-0 bg-kyzzen-primary"
              >
                Kyzzen profile
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Primary wallet address
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Twitter handle
              </th>
              <th
                align="left"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Discord
              </th>
              <th
                align="right"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Leaderboard
              </th>
              <th
                align="right"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Solana contributor
              </th>
              <th
                align="right"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                NFT partner
              </th>
              <th
                align="right"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Token partner
              </th>
              <th
                align="right"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Twitter giveaway
              </th>
              <th
                align="right"
                className="max-w-xs w-1/12 px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary"
              >
                Total spots
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={10}>
                  <MiniDeLoading />
                </td>
              </tr>
            ) : (
              <>
                {filteredQualifications.map((qualification, idx) => (
                  <tr className="w-full group/tbr" key={idx}>
                    <th className="w-[1%] px-2.5 py-3 whitespace-nowrap border-b border-kyzzen-secondary text-sm font-normal">
                      {idx + 1}
                    </th>
                    <td
                      align="left"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary sticky left-0 bg-kyzzen-primary"
                    >
                      {qualification.user.username}
                    </td>
                    <td
                      align="left"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {truncateAddress(qualification.primary_wallet)}
                    </td>
                    <td
                      align="left"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {qualification.user.twitter_username}
                    </td>
                    <td
                      align="left"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {qualification.user.discord_username}
                    </td>
                    <td
                      align="right"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {qualification.wl_leaderboard ? 1 : 0}
                    </td>
                    <td
                      align="right"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {qualification.solana_contributor ? 1 : 0}
                    </td>
                    <td
                      align="right"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {qualification.nft_partner ? 1 : 0}
                    </td>
                    <td
                      align="right"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {qualification.token_partner ? 1 : 0}
                    </td>
                    <td
                      align="right"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {qualification.twitter_giveaway_count}
                    </td>
                    <td
                      align="right"
                      className="max-w-xs w-1/12 px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary"
                    >
                      {(qualification.wl_leaderboard ? 1 : 0) +
                        (qualification.solana_contributor ? 1 : 0) +
                        (qualification.nft_partner ? 1 : 0) +
                        (qualification.token_partner ? 1 : 0) +
                        qualification.twitter_giveaway_count}
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default WhitelistTable
